export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileEletmod');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileEletmod');
    }
}
